<template>
  <div class="container-steps">
    <div class="flex-end">
      <div class="stepper">
        <div v-for="(step, index) in steps" :key="index" class="step">
          <div v-if="isInfo(step)" class="circle__dates">
            <span v-if="valueDate(step) !== ''">{{ typeDate(step) }}</span>
            <span>{{ valueDate(step) }}</span>
          </div>
          <div v-else class="circle__label"
               :class="{
                 completed: step.current && !isStepCancelled(step),
                 cancelled: isStepCancelled(step)
               }">
            <span>{{ setTitle(step.name) }}</span>
          </div>
          <div class="step-distribution">
            <div class="circle"
                 :class="getCircleClasses(step)">
              <template v-if="isInfo(step)">
                <div />
              </template>
              <template v-else-if="isStepCancelled(step)">
                <!-- Círculo cancelled sin contenido -->
              </template>
              <template v-else-if="!step.current">
                <img v-if="step.subtitle === 'Booked'"
                     src="@/assets/scss/icons/truck-solid.svg"
                     alt="assigned"
                     style="width: 20px; margin-top: 3px; margin-left:1px">
                <img v-else-if="step.subtitle === 'Picked Up'"
                     src="@/assets/scss/icons/truck-fast-solid.svg"
                     alt="in transit"
                     style="width: 20px; margin-top: 3px;">
                <img v-else-if="step.subtitle === 'Delivered'"
                     src="@/assets/scss/icons/truck-arrow-right-solid.svg"
                     alt="delivery"
                     style="width: 20px; margin-top: 3px;">
                <template v-else>
                  <span>{{ index + 1 }}</span>
                </template>
              </template>
              <template v-else>
                <i class="pi pi-check"></i>
              </template>
            </div>
            <div v-if="index !== steps.length - 1" class="line" :class="{ inactive: !step.current || isStepCancelled(step) }"/>
          </div>
          <div v-if="!isInfo(step)  && valueDate(step) !== ''" class="circle__dates">
            <span>{{ typeDate(step) }}</span>
            <span>{{ valueDate(step) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import LoadStatusType from "../../../Extend/LoadStatusType";

export default {
  name: "Steps",
  mixins: [LoadStatusType],
  props: {
    loadInformationSteps: {
      type: String,
      required: true
    },
    loadById: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data() {
    return {
      steps: [
        {
          type: 'status',
          info: 'Unassigned, Quotes Requested, Quotes Received, Quoted, Tendered, Dispatched, Assigned, In Transit, Delivered, Completed',
          name: 'Pending',
          subtitle: 'Created',
          date: '',
          current: false,
          showMarker: true,
          completed: false,
        },
        {
          type: 'status',
          info: 'Tendered, Dispatched, Assigned, In Transit, Delivered, Completed',
          name: 'Assigned',
          subtitle: 'Booked',
          date: '',
          current: false,
          showMarker: true,
          completed: false,
        },
        {
          type: 'info',
          info: 'Tendered, Dispatched, Assigned, In Transit, Delivered, Completed',
          name: 'Pickup ETA',
          subtitle: 'Pickup ETA',
          date: '',
          current: false,
          showMarker: true,
          completed: false,
        },
        {
          type: 'status',
          info: 'In Transit, Delivered, Completed',
          name: 'In Transit',
          subtitle: 'Picked Up',
          date: '',
          current: false,
          showMarker: true,
          completed: false,
        },
        {
          type: 'info',
          info: 'In Transit, Delivered, Completed',
          name: 'Delivery ETA',
          subtitle: 'Delivery ETA',
          date: '',
          current: false,
          showMarker: true,
          completed: false,
        },
        {
          type: 'status',
          info: 'Delivered, Completed',
          name: 'Delivered',
          subtitle: 'Delivered',
          date: '',
          current: false,
          showMarker: true,
          completed: false,
        },
      ]
    };
  },
  watch: {
    loadInformationSteps: {
      immediate: true,
      handler() {
        this.updateStepsByStatus(this.loadInformationSteps);
      }
    }
  },
  computed: {
    isLoadCancelled() {
      return ['cancelled', 'declined', 'expired'].includes(this.loadById.load_status.toLowerCase());
    }
  },
  methods: {
    normalizeStatus(status) {
      return status.toLowerCase().trim();
    },
    assignStepFlags(currentStatus) {
      this.steps.forEach((step, index) => {
        const allowedStatuses = step.info.split(',').map((s) => s.trim().toLowerCase());
        if (allowedStatuses.includes(currentStatus)) {
          step.current = true;
          step.completed = true;
          for (let i = 0; i < index; i += 1) {
            this.steps[i].completed = true;
          }
        }
      });
    },
    updateStepsByStatus(loadStatus) {
      const currentStatus = this.normalizeStatus(loadStatus);
      this.steps.forEach((step) => {
        step.current = false;
        step.completed = false;
      });
      this.assignStepFlags(currentStatus);
      if (this.isLoadCancelled) {
        const pendingIndex = this.steps.findIndex((step) => step.name === "Pending");
        if (pendingIndex !== -1) {
          this.steps[pendingIndex].subtitle = this.loadById.load_status;
          this.steps[pendingIndex].current = true;
          this.steps[pendingIndex].completed = true;
        }
      } else {
        switch (this.loadInformationSteps) {
          case "Unassigned":
          case "Quotes Requested":
          case "Quotes Received":
          case "Quoted":
          case "Pending":
            this.pendingMode();
            break;
          case "Tendered":
          case "Assigned":
          case "Dispatched":
            this.assignedMode();
            break;
          case "In Transit":
            this.inTransitMode();
            break;
          case "Delivered":
          case "Completed":
            this.deliveredMode();
            break;
          default:
            break;
        }
      }
    },
    pendingMode() {
      this.steps[0].current = this.loadInformationSteps !== 'Pending';
      this.steps[0].date = this.loadById.created_date ? this.loadById.created_date.slice(0, 10) : "";
    },
    assignedMode() {
      this.steps[1].current = true;
      this.steps[0].date = this.loadById.created_date ? this.loadById.created_date.slice(0, 10) : "";
      this.steps[1].date = this.loadById.tender_accepted_date ? this.loadById.tender_accepted_date.slice(0, 10) : "";
      this.steps[2].date = this.loadById.expected_ship_date ? this.loadById.expected_ship_date.slice(0, 10) : "";
      this.steps[4].date = this.loadById.expected_delivery_date ? this.loadById.expected_delivery_date.slice(0, 10) : "";
    },
    inTransitMode() {
      this.steps[3].current = true;
      this.steps[0].date = this.loadById.created_date ? this.loadById.created_date.slice(0, 10) : "";
      this.steps[1].date = this.loadById.tender_accepted_date ? this.loadById.tender_accepted_date.slice(0, 10) : "";
      this.steps[2].date = this.loadById.expected_ship_date ? this.loadById.expected_ship_date.slice(0, 10) : "";
      this.steps[3].date = this.loadById.actual_pickup_date ? this.loadById.actual_pickup_date.slice(0, 10) : "";
      this.steps[4].date = this.loadById.expected_delivery_date ? this.loadById.expected_delivery_date.slice(0, 10) : "";
    },
    deliveredMode() {
      this.steps[5].current = true;
      this.steps[0].date = this.loadById.created_date ? this.loadById.created_date.slice(0, 10) : "";
      this.steps[1].date = this.loadById.tender_accepted_date ? this.loadById.tender_accepted_date.slice(0, 10) : "";
      this.steps[2].date = this.loadById.expected_ship_date ? this.loadById.expected_ship_date.slice(0, 10) : "";
      this.steps[3].date = this.loadById.actual_pickup_date ? this.loadById.actual_pickup_date.slice(0, 10) : "";
      this.steps[4].date = this.loadById.expected_delivery_date ? this.loadById.expected_delivery_date.slice(0, 10) : "";
      this.steps[5].date = this.loadById.actual_delivery_date ? this.loadById.actual_delivery_date.slice(0, 10) : "";
    },
    isInfo(step) {
      return step.type === 'info';
    },
    valueDate(step) {
      return this.dateFormat(step.date) || '';
    },
    typeDate(step) {
      return step.subtitle || '';
    },
    dateFormat(value) {
      const formattedDate = dayjs(value).format('MM-DD-YYYY');
      if (formattedDate.toLowerCase() === 'invalid date') {
        return value;
      }
      return formattedDate;
    },
    isStepCancelled(step) {
      return (step.name.toLowerCase() === 'pending') && this.isLoadCancelled;
    },
    isLoadTruckPending(step) {
      return step.name.toLowerCase() === 'pending';
    },
    setTitle(name) {
      if (name.toLowerCase() === 'pending' && this.isLoadCancelled) {
        return this.loadById.load_status;
      }
      return name;
    },
    getCircleClasses(step) {
      return {
        completed: (step.current && !this.isStepCancelled(step)) || this.isLoadTruckPending(step),
        cancelled: this.isStepCancelled(step),
        circleCompleted: step.type !== 'info',
        circleInfo: step.type === 'info',
        informative: step.type === 'info' && step.completed,
        'is-eta': this.isInfo(step)
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/_variables' as *;
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/_mixin' as *;

.container-steps {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  margin-left: 8px;
  gap: 10px;

  &__shp {
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    flex-direction: column;
    gap: 15px;

    p {
      font-family: "Montserrat", sans-serif;
      font-size: 16px;
      color: $color-primary-company;
      font-weight: 700;
      margin: 0;
    }
  }

  &__back {
    @include font-small-standart-text;
    font-family: $font-family-portal;
    font-size: 14px;
    display: flex;
    align-items: center;
    margin-left: 1%;
    font-weight: bold;
    width: 160px;
    cursor: pointer;
    width: 100%;
    color: $color-border-container;
    margin-left: 0;

    i {
      font-size: 16px;
      margin-right: 5px;
    }
  }
}

.circleInfo{
  width: 15px ;
  height: 15px;
  margin-top: 10px;
}

.circleCompleted{
  width: 30px;
  height: 30px;
}

.stepper {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  width: 100%;
  text-align: end;

  .step {
    display: grid;
    grid-template-rows: 40px 30px 50px;
  }

  .step-distribution {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
  }

  .circle {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: #ddd;
    font-size: 14px;
    color: #fff;

    &.completed {
      background-color: $color-steps-bar;
    }
    &.informative {
      background-color: $color-steps-bar;
    }
    &.cancelled {
      background-color:#BC272D;
    }

    .step-number {
      font-size: 16px;
    }
    .step-icon {
      font-size: 15px;
      margin-top: 3px;
    }
  }

  .circle__label {
    display: flex;
    justify-content: start;
    align-items: center;
    font-family: "Montserrat", sans-serif;
    font-size: 12px;
    color: #CCCCCC;
    font-weight: 500;

    &.completed {
      color: $color-steps-bar;
      font-weight: 600;
      margin-left: 0px;
    }
    &.cancelled {
      color:#BC272D;
      font-weight: 600;
    }
  }

  .circle__dates {
    display: flex;
    flex-direction: column;
    span {
      font-family: "Montserrat", sans-serif;
      margin-top: 2px;
      font-size: 12px;
      color: #8b8383;
      font-weight: 400;
      text-align: start;
    }
  }
}

.line {
  flex: 1;
  height: 5px;
  background-color: $color-steps-bar;
  margin: 15px 5px 0;

  &.inactive {
    background-color: #CCCCCC;
  }
}

.flex-end {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: end;
  align-items: flex-end;
}

@media (max-width: 1350px) {
  .stepper {
    max-width: none;
  }
  .line {
    flex: 1;
    margin: 15px 5px 0;
  }
}
@media (max-width: 850px) {
  .stepper {
    max-width: none;
  }
  .line {
    flex: 1;
  }
}
@media (max-width: 600px) {
  .container-steps {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    margin-left: 0px;
  }
  .stepper {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    max-width: none;
    padding-left: 0px;
  }
  .line {
    flex: 1;
  }
}
</style>
